export const DUMMY_SWITCHES = {
  'bet-east': ['01', '02', '03', '04', '05'],
  'bet-west': ['01', '02', '03', '04', '05'],
  's.coast': ['01', '02', '03', '04', '05'],
  'north-korea': ['01', '02', '03'],
  'mtl-east': ['01', '02', '03', '04', '05'],
  'mtl-west': ['01', '02', '03', '04', '05'],
  'mtl-south': ['01', '02', '03', '04', '05'],
  'bet-north': ['01', '02', '03', '04'],
  'bet-south': ['01', '02', '03'],
  'n.coast': ['01', '02', '03', '04'],
};

export const DUMMY_LOCATIONS = Object.keys(DUMMY_SWITCHES);
